import { downLoadFile } from 'src/app/core/utils';
import { getGridViewHearders, getGridViewRows } from '../pages/pivote-table/utils/headers';
import { ActionTypes } from './report.action';
import { formatDate } from '@angular/common';

export const INITIAL_ACL_STATE = {

  ExportReportData: {
    ExportReport: undefined,
    loading: false,
    error: false
  },
  ExportPivoteTable: {
    data: undefined,
    loading: false,
    error: false
  },
  pivoteTable: {
    columns: [],
    data: [],
    message: undefined
  },
  SourceList: undefined,
  distinctFilterData: {
    data: undefined,
    loading: false,
    error: false
  }
};

export function ReportsReducer(state = INITIAL_ACL_STATE, action: any): any {
  switch (action.type) {
    case ActionTypes.EXPORT_REPORT_By_ID: {
      return {
        ExportReportData: {
          ...state.ExportReportData,
          ExportReport: undefined,
          loading: true,
          error: false,
        }
      };
    }
    case ActionTypes.EXPORT_REPORT_By_ID_SUCCESS: {
      downLoadFile(action.payload, 'application/ms-excel', action.fileName);
      return {
        ExportReportData: {
          ...state.ExportReportData,
          ExportReport: undefined,
          loading: false,
          error: false,

        }
      };
    }
    case ActionTypes.EXPORT_REPORT_By_ID_ERROR: {
      return {
        ExportReportData: {
          ...state.ExportReportData,
          ExportReport: action.payload,
          loading: false,
          error: true
        }
      };
    }
    case ActionTypes.EXPORT_PIVOTE_TABLE: {
      return {
        ...state,
        ExportPivoteTable: {
          ...state.ExportPivoteTable,
          loading: true,
          error: false,
        },
      };
    }
    case ActionTypes.EXPORT_PIVOTE_TABLE_SUCCESS: {
      const today = new Date();
      const formattedDate = formatDate(today, 'yyyy_MM_dd', 'en-US');
      const fileName = `PivoteTable_${formattedDate}.xlsx`;

      downLoadFile(action.payload, 'application/ms-excel',fileName);
      return {
        ...state,
        ExportPivoteTable: {
          ...state.ExportPivoteTable,
          data: action.payload,
          loading: false,
          error: undefined,
        },
      };
    }
    case ActionTypes.EXPORT_PIVOTE_TABLE_ERROR: {
      return {
        ...state,
        ExportPivoteTable: {
          ...state.ExportPivoteTable,
          error: action.payload,
          loading: false,
        },
      };
    }

    case ActionTypes.LOAD_PIVOTE_TABLE: {
      return {
        ...state,
        pivoteTable: {
          ...state.pivoteTable,
          message: undefined,
          error: undefined,
          data: undefined,
          loading: true,
        },
      };
    }
    case ActionTypes.LOAD_PIVOTE_TABLE_SUCCESS: {
      return {
        ...state,
        pivoteTable: {
          ...state.pivoteTable,
          headers: getGridViewHearders(action?.payload?.headers),
          data: getGridViewRows(action?.payload?.rows),
          message: action?.payload?.message,
          loading: false,
        },
      };
    }
    case ActionTypes.LOAD_PIVOTE_TABLE_ERROR: {
      return {
        ...state,
        pivoteTable: {
          ...state.pivoteTable,
          loading: false,
          error: action.payload,
          data: null,
        },
      }
    }
    case ActionTypes.GET_SOURCE_COLUMNS: {
      return {
        ...state,
        SourceList: {
          list: undefined,
          loading: true,
        },
        error: false,
      };
    }
    case ActionTypes.GET_SOURCE_COLUMNS_SUCCESS: {
      return {
        ...state,
        SourceList: {
          list: action.payload,
          loading: false,
        },
        error: undefined,

      };
    }
    case ActionTypes.GET_SOURCE_COLUMNS_ERROR: {
      return {
        ...state,
        SourceList: {
          list: undefined,
          loading: false,
        },
        loading: true,
        error: action.payload
      };
    }
     // get distinct filter data
        case ActionTypes.GET_DISTINCT_FILTER_DATA: {
          return {
            ...state,
            distinctFilterData: {
              ...state.distinctFilterData,
              loading: true,
            },
          };
        }
        case ActionTypes.GET_DISTINCT_FILTER_DATA_SUCCESS: {
          return {
            ...state,
            distinctFilterData: {
              ...state.distinctFilterData,
              data: action.payload,
              loading: false,
            },
          };
        }
        case ActionTypes.GET_DISTINCT_FILTER_DATA_ERROR: {
          return {
            ...state,
            distinctFilterData: {
              ...state.distinctFilterData,
              loading: false,
              error: action.payload,
            },
          };
        }
  }
}
